/* @ngInject */
const sterileMetadata = (
  sterileFields,
  sterileButtons
) => {
  const self = {}

  self.favoriteSort = ['number',]

  self.buttons = [
    sterileButtons.delete,
  ]

  self.fields = sterileFields

  return self
}
export default sterileMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/metadata.service.js